// extracted by mini-css-extract-plugin
export default {"label":"FormInputNumeric_label__aAC9I"};